var FastSearch = {

    form: {
        button:         null,
        input:          null,
        results:        null,
        getValue:       function() { return this.input.val(); }

    },

    settings: {
        input_selector:	 null,
        url:			 null,
        delay:			 700,
        group_limit:	 4,
        select:			 null,
        onkeyup:		 true
    },

    init_dom: function() {
        var self = this;
        self.form.input = jQuery(self.settings.input_selector);
        self.form.results = jQuery('#fastSearchResults');

        jQuery('#fastSearchContainer div:first a').css( { float: 'right', opacity: .75 } );

        jQuery('#fastSearchContainer')
            .bind('mouseleave', function() {
                self.timer = setTimeout(FastSearch.cancel, 1000);
            })
            .bind('mouseenter', function() {
                clearTimeout(FastSearch.timer);
                jQuery('#fastSearchContainer').show();
            });

        jQuery( window ).resize(self.resize);
        setTimeout(self.resize(), 500);
    },

    resize: function() {
        var search = jQuery("#isn_search");
        var help = jQuery("#menu_help");
        var size = Math.floor(document.body.clientWidth - help.width() - help.offset().left - 175);

        if(size < 50) {
            size = 50;
        }
        search.width(size).show();

        if ($(window).width() < 1000) {
            $('body').attr('style', 'padding-top: 0 !important');
            $('.navbar-isn-fixed-top').attr('style', 'position: relative');
        } else {
            $('body').removeAttr('style');
            $('.navbar-isn-fixed-top').attr('style', 'position: fixed');
        }
    },

    init : function(settings) {
        var self = this;

        jQuery.extend( this.settings, settings );

        self.init_dom();

        if( self.settings.onkeyup ) {
            self.form.input.keyup(function() {
                if( self.timer ) {
                    clearTimeout(self.timer);
                }

                if( ! self.enter_key_fired ) {
                    self.timer = setTimeout(self.doRequest, self.settings.delay);
                }
            } );
        }
        self.form.input.bind("keypress", function(e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if(code == 13) {
                self.enter_key_fired = true;
                self.doRequest(self);
                e.preventDefault();
            }
        } );
    },

    cancel: function() {
        var self = FastSearch;
        self.hideResults();
        jQuery('#fastSearchContainer').hide();
        return false;
    },

    showResults: function(html) {
        jQuery("#fastSearchResults").html(html).show();
    },

    hideResults: function() {
        jQuery("#fastSearchResults").hide();
    },

    anchorContainer: function() {
        var offset = this.form.input.offset();
        var left = offset.left;
        var top = 1;
        jQuery("#fastSearchContainer").css("top", top+"px").css("left", left+"px");
    },

    open: function(url) {
        window.location = url;
    },

    doRequest : function() {
        var self = FastSearch;

        if (self.debounceTimer) {
            clearTimeout(self.debounceTimer);
        }
    
        self.debounceTimer = setTimeout(function() {
            if (self.activeThread != null) {
                self.activeThread.abort();
            }

            if (self.form.getValue().length > 1 && jQuery.trim(self.form.getValue()) != "") {
                jQuery("#fastSearchTopResults").hide();
                self.hideResults();

                var payload = {
                    search_term: self.form.getValue(),
                    group_limit: self.settings.group_limit
                };

                self.activeThread = jQuery.post(self.settings.url, payload, function(data) {
                    self.htmlResults(data, self);
                }, 'json');
            } else {
                self.cancel();
            }
        }, self.settings.delay || 500); // Use delay from settings, default to 500ms
    },

    htmlResults : function(data, object) {
        var self = object;

        if( data.total > 0 ) {
            var html = jQuery("<ul></ul>");
            jQuery.each(data.data, function(i,v) {
                var item_type = v.type.toLowerCase();
                var xhtml_li = jQuery("<li></li>");
                var show_more = '';

                xhtml_li.addClass("fastSearchResult");

                if( v.first ) {
                    var xhtml_li_title = $("<li></li>");
                    if( item_type == "order" && data.totalorders > 0 ) {
                        if (data.showmoreorders >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Inspections ("+data.totalorders+")" + show_more + "</div>");
                    }
                    else if( item_type == "agent" && data.totalagents > 0 ) {
                        if (data.showmoreagents >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Agents ("+data.totalagents+")" + show_more + "</div>");
                    }
                    else if( item_type == "client" && data.totalclients > 0 ) {
                        if (data.showmoreclients >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Clients ("+data.totalclients+")" + show_more + "</div>");
                    }
                    else if( item_type == "agency" && data.totalagencies > 0 ) {
                        if (data.showmoreagencies >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Agencies ("+data.totalagencies+")" + show_more + "</div>");
                    }
                    else if( item_type == "insurance agent" && data.totalinsuranceagents > 0 ) {
                        if (data.showmoreinsuranceagents >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Insurance Agents ("+data.totalinsuranceagents+")" + show_more + "</div>");
                    }
                    else if( item_type == "escrow officer" && data.totalescrowofficers > 0 ) {
                        if (data.showmoreescrowofficers >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Escrow Officers ("+data.totalescrowofficers+")" + show_more + "</div>");
                    }
                    else if( item_type == "user" && data.totalusers > 0 ) {
                        if (data.showmoreusers >= data.limit)
                            show_more = "<a href=\"" + ISN.get_url('/fastsearch?s=' + self.form.getValue()) + "\" class=\"pull-right\">show more</a>";
                        xhtml_li_title.append("<div class=\"fastSearchGroupHeader\">Users ("+data.totalusers+")" + show_more + "</div>");
                    }
                    html.append(xhtml_li_title);
                }

                var link = jQuery("<div></div>").addClass("fastSearchResultRow").html("<table><tr><th align=\"left\" style=\"width:32px;\">"+v.image+"</th><td align=\"left\">"+v.value+"</td></tr></table>");

                if( v.canceled || v.deleted ) {
                    link.addClass("fastSearchResultDeleted");
                }
                else if( v.incomplete ) {
                    link.addClass("fastSearchResultIncomplete");
                }

                xhtml_li.append(link);

                xhtml_li.click(
                    function() {
                        self.settings.select(v.url);
                    }
                );

                html.append(xhtml_li);

            } );

            self.showResults(html);
            jQuery("#fastSearchContainer").show().width($("#isn_search").width()+34+34);
            self.anchorContainer();
            jQuery("#fastSearchTopResults").show();
            jQuery(".fastSearchResultRow").highlight(self.form.getValue(), "fastSearchHighlightResult");
        }
        else {
            self.showResults("No results found for: "+self.form.getValue());
            jQuery("#fastSearchContainer").show().width($("#isn_search").width()+34+34);
            self.anchorContainer();
        }

        self.enter_key_fired = false;
        self.activeThread = null;
    }
};
